import { FC, ReactNode } from "react";

interface ContentFrameworkProps {
  children: ReactNode;
}

const ContentFramework: FC<ContentFrameworkProps> = ({ children }) => {
  return (
    <>
      <div className="flex flex-grow flex-col bg-[var(--background-color)] dark:bg-[#131313] p-1 text-gray-800 dark:text-gray-200 md:p-5 xl:flex-row">
        <main className="w-full flex-grow rounded shadow-sm lg:w-auto">
          {children}
        </main>
      </div>
    </>
  );
};

interface LightFrameworkProps {
  children: ReactNode;
}

export const LightFramework: FC<LightFrameworkProps> = ({ children }) => {
  return (
    <>
      <div className="h-full w-full">{children}</div>
    </>
  );
};

export default ContentFramework;
